<script>
  // import { isApp } from '@st-graphics/graphics-kit/environment';
  import ArticleHead from './ArticleHead/ArticleHead.svelte';
  import { copyJson } from '$lib/stores/st-lf.svelte';
</script>

<ArticleHead
  credits={copyJson.data?.credits}
  head={copyJson.data?.header}
  menu={copyJson.data?.menu}
/>

<style lang="scss">
</style>
